import '../../blocks/installer-form/installer-form.scss';
import '../../blocks/ring-breadcrumbs/ring-breadcrumbs.scss';
import './upgrade-source.scss';
import InstallerResource from '../../blocks/resource/resource';
import WizardInfo from '../../blocks/wizard-info/wizard-info';
import ManageOldUpgrade from '../../blocks/manage-old-upgrade/manage-old-upgrade';

import UpgradeSourceTemplate from './upgrade-source.html';

import UpgradeSourceController from './upgrade-source__controller';

export default angular.module('installer.upgrade-source', [
  InstallerResource.name,
  WizardInfo.name,
  ManageOldUpgrade
]).
  controller('UpgradeSourceController', UpgradeSourceController).
  config($routeProvider => {
    $routeProvider.
      when('/upgrade/source', {
        template: UpgradeSourceTemplate,
        controller: 'UpgradeSourceController as ctrl',
        reloadOnSearch: false
      });
  });



// WEBPACK FOOTER //
// ./src/pages/upgrade-source/upgrade-source.js